<template>
  <v-row>
    <component v-bind:is="getSubTab.component" />
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Product',
  methods: {
    ...mapActions(['fetchFiles']),
  },
  mounted() {
    this.fetchFiles();
  },
  computed: {
    ...mapGetters(['getSubTab']),
  },
};
</script>
